import React, { useRef, useState, useEffect } from "react";
import { useLocation, withRouter } from "react-router-dom";
import { isEdge } from "react-device-detect";
import { connect } from "react-redux";
import { Col, Row } from "reactstrap";
import { Auth } from "aws-amplify";
import { compose } from "redux";
import cx from "classnames";
import _ from "lodash";

import Alert from "components/shared/common/alert";
import InGameChangeTeam from "components/team/inGameChangeTeam";
import * as gameAction from "redux/game/action";
import * as loaderAction from "redux/loader/action";
import * as signinAction from "redux/signin/action";
import * as webUrlAction from "redux/webUrl/action";
import * as socketAction from "redux/sockets/action";
import * as paramsAction from "redux/gameParams/actions";
import Socket from "socket/socket";
import Footer from "./Footer";
import SideBarTabs from "./sideBarTabs";
import HeroSec from "./HeroSec/HeroSec";
import TeamCapacityModal from "./teamCapacityModal";
import MiddleSection from "./Activity/MiddleSection";
import TeamAct from "./Activity/TeamActivity/TeamAct";

let hosturl;
let viewerurl;

const LandingLibrary = (props) => {
  const search = useLocation().search;
  const heroParams = _.get(props, "gameReducer.gamesData.game_library_v2.hero");
  const pick_activity = _.get(
    props,
    "gameReducer.gamesData.game_library_v2.pick_activity"
  );
  const team_session_params = _.get(
    props,
    "gameReducer.gamesData.game_library_v2.team_session"
  );

  const browseActivity = _.get(
    props,
    "gameReducer.gamesData.game_library_v2.browse"
  );
  const gameReducer = _.get(props, "gameReducer");
  const session_id = _.get(gameReducer, "session_id");
  const magicLinkObj = _.get(props, "gameReducer.magicLinkObj");

  const set_session_id = _.get(props, "set_session_id");
  const setMagicLinkData = _.get(props, "setMagicLinkData");
  const current_user = _.get(gameReducer, "currentUser");
  const team = _.get(current_user, "team");
  const teamCode = _.get(team, "id");
  const [notSignedIn, setnotSignedIn] = useState(false);
  const teamSessionRef = useRef(null);
  const [goingUp, setGoingUp] = useState(false);

  const socket_connected = _.get(props, "socketReducer.socketConnection");
  const sessionObj = _.get(props, "gameReducer.sessionObj");
  const link = _.get(sessionObj, "branch_url");
  const sessionId = _.get(sessionObj, "session_id");
  const [disableForStrictMode, setDisableForStrictMode] = useState(false);
  const [teamCapacityExcededModal, setTeamCapacityExcededModal] =
    useState(false);
  const inGameChangeTeamState = _.get(
    props,
    "gameReducer.inGameChangeTeamState"
  );

  const reset_magic_link_details = () => {
    sessionStorage.setItem("joinTeamFlow", false);
    setMagicLinkData({});
    props.setInGameChangeTeamState(false);
    props.history.replace("/");
  };

  useEffect(() => {
    sessionStorage.getItem("joinTeamFlow") && props.history.replace("/");
    window.addEventListener("beforeunload", reset_magic_link_details);
    return () =>
      window.removeEventListener("beforeunload", reset_magic_link_details);
  }, []);

  useEffect(() => {
    const magicBranchUrl = new URLSearchParams(search).get("_branch_match_id");
    if (
      !_.isEmpty(team) &&
      !inGameChangeTeamState &&
      magicBranchUrl === null &&
      current_user.userId === team.manager &&
      "access_token" in current_user
    ) {
      if (team.count > team.limit) {
        setTeamCapacityExcededModal(true);
      } else {
        setTeamCapacityExcededModal(false);
      }
    }
  }, [team, search, current_user, inGameChangeTeamState]);

  useEffect(() => {
    var cognitoUser = Auth.userPool.getCurrentUser();
    if (cognitoUser !== null) {
      setnotSignedIn(false);
    } else {
      setnotSignedIn(true);
    }
  }, []);

  useEffect(() => {
    if (_.isEmpty(current_user?.team)) {
      props.setSession({});
      props.setSessionLink(null);
    }
  }, [current_user]);

  useEffect(() => {
    const magicBranchUrl = new URLSearchParams(search).get("_branch_match_id");
    if (!_.isEmpty(magicLinkObj)) {
      disableForStrictMode && setDisableForStrictMode(false);
      branchData();
    } else if (isEdge && magicBranchUrl !== null) {
      setTimeout(() => {
        branchData();
        setDisableForStrictMode(true);
      }, 2000);
    }
  }, [magicLinkObj, disableForStrictMode]);

  useEffect(() => {
    if (!_.isEmpty(search) && sessionStorage.getItem("joinTeamFlow") === null) {
      sessionStorage.setItem("alertOnce", "no");
      try {
        window.branch.init(
          "key_live_ddQZA5RPj07v525mmuaiOkijzuh2BTjo",
          function (err, data) {
            console.log(err, "errorrrr==>>");
            !_.isEmpty(data?.data_parsed) &&
              _.isEmpty(magicLinkObj) &&
              setMagicLinkData({
                ...magicLinkObj,
                team_code: data.data_parsed["$promocode"],
                team_name: data.data_parsed.team_name,
                expiration_time: data.data_parsed.expirationTime
              });
          }
        );
      } catch (err) {
        console.error("Error in Branch.io initialization:");
        // Handle any other errors that might occur during the try block.
      }
    }
  }, [search]);

  const branchData = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser({
        bypassCache: true
      });
      props.setInGameChangeTeamState(true);
    } catch (error) {
      props.history.push("/signup");
    }
  };

  useEffect(() => {
    return Socket.addListener(
      "join-game-host",
      on_join_game_host,
      log_on_error
    );
  }, []);

  useEffect(() => {
    return Socket.addListener(
      "join-game-viewer",
      on_join_game_viewer,
      log_on_error
    );
  }, []);

  useEffect(() => {
    return Socket.addListener("get-room", on_get_room, log_on_error);
  }, []);

  const reset = () => {
    props.endGame(true);
    props.emptyGameData({});
    props.togglePlayAgain(false);
    props.setWellnessParamsOnject({});
  };

  useEffect(() => {
    reset();
    props.set_password_reset_details({ email: "", code_success: false });
    props.set_sign_in_details({ sign_up: false, sign_up_with_email: false });
  }, []);

  useEffect(() => {
    if (socket_connected) {
      const location = window.location.href;
      const search = location.includes("?") ? location.split("?")[1] : "";
      if (!search) return;
      const url_prarms = search.split("&");
      if (url_prarms[0] === "host") {
        hosturl = new URLSearchParams(url_prarms[1]).get("joincode");
        localStorage.setItem("hostjoinCode", hosturl);
        handle_join_game_as_host(hosturl);
      }
      if (url_prarms[0] === "viewer") {
        const searchViewer = url_prarms[1];
        viewerurl = new URLSearchParams(searchViewer).get("joincode");
        localStorage.setItem("viewerjoinCode", viewerurl);
        handle_join_game_as_viewer(viewerurl);
      }
    }
  }, [socket_connected]);

  const on_get_room = async (res) => {
    if (res && res.room) {
      let localHostCode = localStorage.getItem("hostjoinCode");
      const currentUser = await Auth.currentAuthenticatedUser();
      if (res.room.host_user_id === currentUser.username) {
        let data = {
          action: "join-game-host",
          joinCode: hosturl ? hosturl : localHostCode,
          userId: currentUser?.username
        };
        Socket.sendMessage(data);
        localStorage.removeItem("hostjoinCode");
      } else {
        props.setIsLoading(false);
        sessionStorage.setItem("gameCode", res.room.game_code);
        props.history.push("/wronghost");
      }
    }
  };

  const log_on_error = async (err) => {
    Alert(400, err.error);
    await Auth.signOut()
      .then((user) => {
        props.endGame(true);
        props.setCurrentUser({});
        props.setIsLoading(false);
        props.history.push("/signup");
      })
      .catch((err) => {
        console.log("errorrrrrr", err);
      });
    console.log(err);
  };

  const handle_join_game_as_host = async () => {
    var cognitoUser = await Auth.userPool.getCurrentUser();
    props.setIsLoading(true);
    if (cognitoUser !== null) {
      localStorage.setItem("webUrl", true);
      localStorage.setItem("branchlinkforviewer", true);
      let data = {
        action: "get-room",
        joinCode: hosturl
      };
      Socket.sendMessage(data);
    } else {
      props.history.push("/signup");
    }
  };

  const handle_join_game_as_viewer = () => {
    localStorage.setItem("webUrl", true);
    localStorage.setItem("branchlinkforviewer", true);
    let data = {
      action: "join-game-viewer",
      joinCode: viewerurl,
      userId: props?.gameReducer?.currentUser?.userId
    };
    Socket.sendMessage(data);
  };

  const on_join_game_host = (res) => {
    if (res && res.room) {
      if (JSON.parse(localStorage.getItem("webUrl"))) {
        props.setIsLoading(false);
        props.history.push("/lobby");
      }
    }
  };

  const on_join_game_viewer = (res) => {
    if (res && res.room) {
      if (JSON.parse(localStorage.getItem("webUrl"))) {
        props.setGameName(res.room.game_code);
        props.setViewerWebUrl(true);
        props.history.push("/lobby");
      }
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (currentScrollY > teamSessionRef.current?.offsetTop + 600) {
        setGoingUp(true);
      } else {
        setGoingUp(false);
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [goingUp]);

  return (
    <>
      {inGameChangeTeamState && (
        <InGameChangeTeam
          current_user={current_user}
          magicLinkObj={magicLinkObj}
          setCurrentUser={props.setCurrentUser}
          disableForStrictMode={disableForStrictMode}
          reset_magic_link_details={reset_magic_link_details}
        />
      )}
      {teamCapacityExcededModal && (
        <TeamCapacityModal
          team={team}
          history={props.history}
          isOpen={teamCapacityExcededModal}
          onClose={() => setTeamCapacityExcededModal(false)}
        />
      )}
      <div
        className={cx("library-main", {
          disableForStrictMode: disableForStrictMode
        })}
      >
        <Row className="lib-row">
          <Col md={1} className="p-0">
            <SideBarTabs
              current_user={current_user}
              handleOptClick={() =>
                props.history.push("/outside_team_building")
              }
            />
          </Col>
          <Col md={11} className="p-0">
            <HeroSec
              heroParams={heroParams}
              notSignedIn={notSignedIn}
              setIsLoading={props.setIsLoading}
            />
            <MiddleSection
              link={link}
              sessionId={sessionId}
              history={props.history}
              session_id={session_id}
              currentUser={current_user}
              pick_activity={pick_activity}
              set_session_id={set_session_id}
              teamSessionRef={teamSessionRef}
              sessionUsers={sessionObj?.users}
              team_session={team_session_params}
              socket_connected={socket_connected}
            />
            <TeamAct browseActivity={browseActivity} />
            {!_.isEmpty(current_user?.team) && (
              <Footer
                link={link}
                goingUp={goingUp}
                teamCode={teamCode}
                sessionId={sessionId}
                sessionUsers={sessionObj?.users}
                team_session={team_session_params}
              />
            )}
          </Col>
        </Row>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  socketReducer: state.socketReducer
});

const mapDispatchToProps = (dispatch) => ({
  endGame: (data) => dispatch(gameAction.endGame(data)),
  setSession: (data) => dispatch(gameAction.setSession(data)),
  setGameName: (data) => dispatch(gameAction.setGameName(data)),
  setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
  set_session_id: (data) => dispatch(gameAction.set_session_id(data)),
  setSessionLink: (data) => dispatch(gameAction.setSessionLink(data)),
  emptyGameData: (data) => dispatch(paramsAction.emptyGameData(data)),
  setCurrentUser: (data) => dispatch(gameAction.setCurrentUser(data)),
  setMagicLinkData: (data) => dispatch(gameAction.setMagicLinkData(data)),
  setInGameChangeTeamState: (data) =>
    dispatch(gameAction.setInGameChangeTeamState(data)),
  setViewerWebUrl: (data) => dispatch(webUrlAction.setViewerWebUrl(data)),
  setMagicLink: (data) => dispatch(socketAction.setMagicLink(data)),
  togglePlayAgain: (data) => dispatch(socketAction.togglePlayAgain(data)),
  set_sign_in_details: (data) =>
    dispatch(signinAction.set_sign_in_details(data)),
  set_password_reset_details: (data) =>
    dispatch(signinAction.set_password_reset_details(data)),
  setWellnessParamsOnject: (data) =>
    dispatch(gameAction.setWellnessParamsOnject(data))
});

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(LandingLibrary);
